import React, { useCallback, useMemo } from 'react';
import { cn } from '../../../lib/utils';
import { useAnalytics } from '../../../hooks/useAnalytics';

const FrequencyStep = React.memo(({
  data = {},
  onChange,
  disabled = false
}) => {
  const { frequency = '' } = data;
  const analytics = useAnalytics();

  const frequencyOptions = useMemo(() => [
    {
      id: 'weekly',
      label: 'Multiple times a week'
    },
    {
      id: 'biweekly',
      label: 'Once a week'
    },
    {
      id: 'monthly',
      label: 'Once or twice a month'
    },
    {
      id: 'quarterly',
      label: 'Every few months'
    },
    {
      id: 'rarely',
      label: 'Rarely'
    }
  ], []);

  const handleFrequencyChange = useCallback((newFrequency) => {
    onChange({ ...data, frequency: newFrequency });

    // Track frequency selection
    analytics.trackFrequencySelect(newFrequency, 3);
  }, [data, onChange, analytics]);

  return (
    <div className="space-y-6">
      <div>
        <h3 tabIndex={-1} className="survey-heading text-2xl font-['Space_Grotesk'] font-medium mb-2 text-white">
          How often do you attend music events?
        </h3>
        <p className="text-sm text-white/60">
          Choose one option
        </p>
      </div>

      <div className="space-y-2">
        {frequencyOptions.map((option) => {
          const isSelected = frequency === option.id;

          return (
            <button
              key={option.id}
              type="button"
              onClick={() => handleFrequencyChange(option.id)}
              disabled={disabled}
              className={cn(
                "w-full text-left px-4 py-3.5 rounded-lg",
                "border transition-all duration-200",
                "text-white/90 hover:text-white",
                "border-white/20",
                isSelected
                  ? "bg-white/15 border-white/30"
                  : "hover:bg-white/10",
                disabled && "opacity-50 cursor-not-allowed"
              )}
              aria-label={`${isSelected ? 'Selected: ' : 'Select '} ${option.label}`}
              aria-pressed={isSelected}
            >
              <span className="text-[15px] leading-relaxed">{option.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
});

FrequencyStep.displayName = 'FrequencyStep';

export default FrequencyStep;
